<mat-card>
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">{{'header.department' | translate}}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'enterprise-certificate_management.ttl_search' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <!-- Search form -->
          <form>
            <div class="row">
              <div class="col-lg-4">
                <mat-form-field class="mat-full-width">
                    <input type="text" #focusInput matInput
                           [placeholder]="'department_manage.department_code_search' | translate" name="enterpriseName"
                           maxlength="200" [(ngModel)]="digitalCertificate.nameOrCode" autocomplete="off"/>
                    <button mat-button *ngIf="digitalCertificate.nameOrCode" type="button" matSuffix mat-icon-button aria-label="Clear"
                    (click)="digitalCertificate.nameOrCode=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  </mat-form-field>
              </div>
              <div class="col-lg-4">
                <mat-form-field class="mat-full-width">
                  <mat-label>{{'department_manage.cbx_status.lbl_status' | translate}}</mat-label>
                  <mat-select #statusSelect id="active" name="active" [(ngModel)]="digitalCertificate.status" (ngModelChange)="onFilterData(0, paginate.pageSize)">
                    <mat-option value="null" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'department_manage.cbx_status.all' | translate}}</mat-option>
                    <mat-option value="true" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'department_manage.cbx_status.active' | translate}}
                    </mat-option>
                    <mat-option value="false" (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'department_manage.cbx_status.inactive' | translate}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4">
                <mat-form-field class="mat-full-width">
                  <mat-label>{{'enterprise_user_management.cbx_type.lbl_type' | translate}}</mat-label>
                  <mat-select #departmentType id="active" name="active" [(ngModel)]="digitalCertificate.departmentType" (ngModelChange)="onFilterData(0, paginate.pageSize)">
                    <mat-option [value]="null" selected (click)="this.commonService.closeDropdownList(this.departmentType)">
                      {{'enterprise_user_management.cbx_type.lbl_all' | translate}}</mat-option>
                    <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.departmentType)">
                      {{'enterprise_user_management.cbx_type.lbl_depart' | translate}}
                    </mat-option>
                    <mat-option [value]="2" (click)="this.commonService.closeDropdownList(this.departmentType)">
                      {{'enterprise_user_management.cbx_type.lbl_branch' | translate}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-12 text-center">
                <button mat-stroked-button color="primary" type="submit" (click)="onFilterData()">
                  <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                  {{'enterprise-certificate_management.buttons.search' | translate}}
                </button>
              </div>
            </div>
          </form>

        </mat-expansion-panel>
      </mat-accordion>
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">

          <mat-panel-title class="mat-panel-title mt-3 d-flex justify-content-between align-items-center">
            <span>{{'department_manage.department_list' | translate}} ({{paginate.totalRow}})</span>
            <button class="pull-right" (click)="openDialogAdd()" mat-stroked-button color="primary" [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">add_circle</mat-icon>{{'enterprise-certificate_management.buttons.add' | translate}}
            </button>
          </mat-panel-title>

          <!-- Start table -->
          <div class="mat-table-container">
            <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">

              <!-- Số thứ tự -->
              <ng-container matColumnDef="stt">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                  {{element.STT}}
                </mat-cell>
              </ng-container>

              <!-- Code -->
              <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'department_manage.table_headers.department_code' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-cell-non-boder-right-bottom word-break-line" matTooltip="{{element.code}}">
                  {{element.code}}
                </mat-cell>
              </ng-container>

              <!-- Name -->
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'department_manage.table_headers.department_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-cell-non-boder-right-bottom word-break-line" matTooltip="{{element.name}}">
                  {{element.name}}
                </mat-cell>
              </ng-container>

              <!-- departmentType -->
              <ng-container matColumnDef="departmentType">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'enterprise_user_management.cbx_type.lbl_type' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-cell-non-boder-right-bottom word-break-line" matTooltip="{{getDepartmentType(element.departmentType)}}">
                  {{getDepartmentType(element.departmentType)}}
                </mat-cell>
              </ng-container>

              <!-- Người đại diện -->
              <ng-container matColumnDef="fullName">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'department_manage.table_headers.department_representative' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                          matTooltip="{{ element.fullName }}">
                  <span class="fix-width fw-100">{{element.fullName}}</span>
                </mat-cell>
              </ng-container>

              <!-- Mô tả phòng -->
              <ng-container matColumnDef="description">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center">
                  {{'department_manage.table_headers.description' | translate}}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="word-break-line"
                          matTooltip="{{ element.description }}">
                  {{element.description}}
                </mat-cell>
              </ng-container>

              <!-- Trạng thái -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef
                                 class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom">
                  {{ "department_manage.table_headers.status" | translate }}
                </mat-header-cell>
               <mat-cell *matCellDef="let element"
                          class="mat-header-cell-center status-col mat-cell-non-boder-right-bottom"
                          matTooltipClass="matTooltipBreakLine"
                         [matTooltip]="(element.status&& getPermisionSME)? ('system_document_template.tooltips.icon_status_active' | translate) :
                (!element.status && getPermisionSME)? ('system_document_template.tooltips.icon_status_inactive' | translate) :
                (element.status) ? ('department_manage.tooltips.icon_status_active' | translate) : ('department_manage.tooltips.icon_status_inactive' | translate)">
                  <button mat-icon-button [disabled]="commonService.getIsLockedEnterprise() || getPermisionSME"
                  (click)="onChangeDepartmentStatus(element, element.status)">
                  <mat-icon matTooltipClass="matTooltipBreakLine"
                    *ngIf="element.status">lock_open</mat-icon>
                  <mat-icon matTooltipClass="matTooltipBreakLine"
                    *ngIf="!element.status">lock</mat-icon>
                </button>
                </mat-cell>
              </ng-container>


              <!-- Tác động Column -->
              <ng-container matColumnDef="action" class="mat-column-symbol mat-cell-non-boder-bottom">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col mat-cell-non-boder-bottom"
                  style="max-width: 28%;">
                  {{'headertable.action' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col"
                  (click)="$event.stopPropagation()" style="max-width: 28%;">
                  <!--  edit  -->
                  <button mat-icon-button [disabled]="commonService.getIsLockedEnterprise() || getPermisionSME"
                          (click)="editDepartment(element)">
                    <mat-icon matTooltip="{{'department_manage.buttons.edit' | translate}}">
                      edit</mat-icon>
                  </button>
                  <!--  Gan nguoi dai dien  -->
                  <!-- <button mat-icon-button (click)="assignRepresentative(element)">
                    <mat-icon matTooltip="{{'department_manage.buttons.assign' | translate}}">person_add
                    </mat-icon>
                  </button> -->
                  <!--  view detail  -->
                  <ng-container *ngIf="!getPermisionSME">
                    <button mat-icon-button
                          (click)="viewUsersDepartment(element)"
                          [disabled]="commonService.getIsLockedEnterprise()">
                    <mat-icon matTooltip="{{'department_manage.config' | translate}}">
                      supervisor_account</mat-icon>
                  </button>
                  </ng-container>

                <!--  Them nguoi dung  -->
                <!-- <button mat-icon-button (click)="addUserDepartment(element)" [disabled]="!element.status">
                  <mat-icon matTooltip="{{'department_manage.buttons.list' | translate}}">supervisor_account
                  </mat-icon>
                </button> -->
                <!-- xóa người dùng -->
                <ng-container *ngIf="!getPermisionSME">
                  <button mat-icon-button
                          (click)="delete(element)"
                          [disabled]="commonService.getIsLockedEnterprise()">
                  <i class="fa fa-trash" aria-hidden="true" [ngClass]="{'disabled-locked': commonService.getIsLockedEnterprise()}"
                    matTooltip="{{'department_manage.buttons.delete' | translate}}"></i>
                </button>
              </ng-container>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row">
              </mat-row>
            </mat-table>
          </div>
          <!-- End table -->

          <!-- Pagination -->
          <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
          </app-pagination>
        </mat-expansion-panel>
      </mat-accordion>



    </mat-card-content>
  </mat-card>
